import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useIntl } from 'react-intl-next';
var ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
var resolveRecommendationRequest = function resolveRecommendationRequest(_ref) {
  var baseUrl = _ref.baseUrl,
    context = _ref.context,
    includeUsers = _ref.includeUsers,
    includeTeams = _ref.includeTeams,
    query = _ref.query,
    maxNumberOfResults = _ref.maxNumberOfResults;
  return {
    baseUrl: baseUrl,
    context: context,
    maxNumberOfResults: maxNumberOfResults,
    query: query !== null && query !== void 0 ? query : '',
    searchQueryFilter: ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
    includeUsers: includeUsers !== null && includeUsers !== void 0 ? includeUsers : false,
    includeGroups: false,
    includeTeams: includeTeams !== null && includeTeams !== void 0 ? includeTeams : false
  };
};
var asyncGetUserRecommendations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, intl) {
    var _yield$import, getUserRecommendations;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/getUserRecommendations" */'@atlaskit/smart-user-picker');
        case 3:
          _yield$import = _context.sent;
          getUserRecommendations = _yield$import.getUserRecommendations;
          return _context.abrupt("return", getUserRecommendations(request, intl));
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function asyncGetUserRecommendations(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var usePeopleAndTeamsQuery = function usePeopleAndTeamsQuery(peopleAndTeamSections, maxItemsPerSection) {
  var intl = useIntl();
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query, _ref3) {
      var baseUrl, context, resolveTeamUrl, resolveUserUrl, teamsRequest, usersRequest, _teams$map, _users$map, _yield$Promise$all, _yield$Promise$all2, teams, users, teamResults, userResults;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            baseUrl = _ref3.baseUrl, context = _ref3.context, resolveTeamUrl = _ref3.resolveTeamUrl, resolveUserUrl = _ref3.resolveUserUrl;
            teamsRequest = resolveRecommendationRequest({
              includeTeams: true,
              baseUrl: baseUrl,
              context: context,
              query: query,
              maxNumberOfResults: 20
            }); // Separate requests enables better empty query results for each section
            usersRequest = resolveRecommendationRequest({
              includeUsers: true,
              baseUrl: baseUrl,
              context: context,
              query: query,
              maxNumberOfResults: 20
            });
            _context2.prev = 3;
            _context2.next = 6;
            return Promise.all([asyncGetUserRecommendations(teamsRequest, intl), asyncGetUserRecommendations(usersRequest, intl)]);
          case 6:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            teams = _yield$Promise$all2[0];
            users = _yield$Promise$all2[1];
            teamResults = (_teams$map = teams === null || teams === void 0 ? void 0 : teams.map(function (team) {
              return {
                title: team.name,
                id: team.id,
                meta: '',
                url: resolveTeamUrl ? resolveTeamUrl(team.id) : "/people/team/".concat(team.id),
                iconUrl: team.avatarUrl,
                isVerified: team.verified
              };
            })) !== null && _teams$map !== void 0 ? _teams$map : [];
            userResults = (_users$map = users === null || users === void 0 ? void 0 : users.map(function (user) {
              return {
                title: user.name,
                id: user.id,
                meta: user.title || '',
                url: resolveUserUrl ? resolveUserUrl(user.id) : "/people/".concat(user.id),
                iconUrl: user.avatarUrl
              };
            })) !== null && _users$map !== void 0 ? _users$map : [];
            return _context2.abrupt("return", {
              sections: [_objectSpread(_objectSpread({}, peopleAndTeamSections.people), {}, {
                searchResults: maxItemsPerSection ? userResults.slice(0, maxItemsPerSection) : userResults
              }), _objectSpread(_objectSpread({}, peopleAndTeamSections.teams), {}, {
                searchResults: maxItemsPerSection ? teamResults.slice(0, maxItemsPerSection) : teamResults
              })]
            });
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", {
              sections: [_objectSpread(_objectSpread({}, peopleAndTeamSections.people), {}, {
                searchResults: []
              }), _objectSpread(_objectSpread({}, peopleAndTeamSections.teams), {}, {
                searchResults: []
              })]
            });
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 15]]);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};